if (!customElements.get('andree-marquee')) {
  class AndreeMarquee extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.track = this.querySelector('.andree-marquee__track');
      this.control = this.querySelector('.andree-marquee__control');
      if (!this.track || !this.control) return;
      this.handleToggle = () => this.toggle();
      this.control.addEventListener('click', this.handleToggle);
    }

    disconnectedCallback() {
      if (this.control && this.handleToggle) {
        this.control.removeEventListener('click', this.handleToggle);
      }
    }

    toggle() {
      const paused = this.control.getAttribute('aria-pressed') === 'true';
      const nextPaused = !paused;
      this.control.setAttribute('aria-pressed', String(nextPaused));
      this.control.setAttribute(
        'aria-label',
        nextPaused ? 'Reanudar movimiento' : 'Pausar movimiento'
      );
      this.track.style.animationPlayState = nextPaused ? 'paused' : 'running';
    }
  }

  customElements.define('andree-marquee', AndreeMarquee);
}
